module.exports = __webpack_public_path__ + "static/media/business-time.c86b35e2.svg";